var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoDirectional(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    stroke: "#566480"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 15.2125C10.2497 14.9512 10.3517 14.7005 10.5334 14.5159L17.3312 7.59697C17.5737 7.33812 17.9349 7.23329 18.2751 7.3231C18.6152 7.41291 18.8808 7.68325 18.969 8.0294C19.0572 8.37554 18.9541 8.74312 18.6996 8.98974L12.5872 15.2105L18.6996 21.4313C18.9512 21.6786 19.0522 22.0449 18.9636 22.3892C18.875 22.7336 18.6107 23.0026 18.2722 23.0927C17.9338 23.1829 17.5739 23.0802 17.3308 22.8241L10.5338 15.9087C10.3517 15.7245 10.2495 15.4738 10.25 15.2125Z",
    fill: "#666666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoDirectional);
export default __webpack_public_path__ + "media/demo-directional.03b6b0b6.svg";
export { ForwardRef as ReactComponent };